import { render, staticRenderFns } from "./SiteSettings.vue?vue&type=template&id=4b5dc11e"
import script from "./SiteSettings.vue?vue&type=script&lang=js"
export * from "./SiteSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports